/**
 * @function filterRoles
 * @param { array } roles1
 * @param { array } roles2
 * @returns { array }
 */
function filterRoles(roles1, roles2) {
	const results = roles1.filter((r1) => !roles2.some((r2) => r1.id === r2.id));

	if (results === undefined) {
		const msg = 'The filtered value is the undefined value!';
		throw new Error(msg);
	}

	return results;
}

export default filterRoles;
